<template>
  <m-layout-grid>
    <m-layout-grid-inner>
      <m-layout-grid-cell
        :span-phone="4"
        :span-tablet="8"
        :span-desktop="12"
        class="app-portada__buscador-simple__title"
        >Búsqueda por texto libre</m-layout-grid-cell
      >
      <m-layout-grid-cell
        :span-phone="4"
        :span-tablet="8"
        :span-desktop="12"
        class="app-portada__buscador-simple__text"
      >
        Si conoces el nombre del inmueble o localización indícalo libremente
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="4" :span-tablet="5" :span-desktop="10">
        <m-text-field
          v-model="textoBusquedaSimple"
          id="textfield-busqueda-simple"
          aria-label="Texto busqueda simple"
          outlined
          class="app-portada__buscador-simple__textfield"
          v-on:keyup.native.enter="routeToInmuebles"
        >
          <m-line-ripple slot="bottomLine" />
        </m-text-field>
      </m-layout-grid-cell>
      <m-layout-grid-cell
        :span-phone="4"
        :span-tablet="3"
        :span-desktop="2"
        class="app-portada__buscador-simple__button"
      >
        <m-button outlined @click="routeToInmuebles">
          Buscar
        </m-button>
      </m-layout-grid-cell>
    </m-layout-grid-inner>
  </m-layout-grid>
</template>

<script>
export default {
  name: "app-portada-buscador-simple",
  data() {
    return {
      textoBusquedaSimple: ""
    };
  },
  methods: {
    routeToInmuebles() {
      this.$router.push(this.routerLinkTotViewWithFilter("/inmuebles"));
    },
    routerLinkTotViewWithFilter(path) {
      var queryParams = {
        busqueda: this.textoBusquedaSimple.trim()
      };

      return { path: path, query: queryParams };
    }
  }
};
</script>

<style lang="scss">
@import "@material/layout-grid/mdc-layout-grid.scss";

.app-portada__buscador-simple__title {
  font-weight: bold;
  text-align: center;
  color: #455a64;
}

.app-portada__buscador-simple__text {
  text-align: center;
  color: #607d8b;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-portada__buscador-simple__title {
    font-size: 24px;
  }
  .app-portada__buscador-simple__text {
    font-size: 16px;
  }
}

.app-portada__buscador-simple__textfield {
  width: 100%;
}

.app-portada__buscador-simple__textfield {
  width: 100%;
}

.app-portada__buscador-simple__button {
  .mdc-button {
    width: 100%;
    height: 56px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-portada__buscador-simple__button {
    .mdc-button {
      height: 100%;
    }
  }
}
</style>
